var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "commission-txt",
    on: {
      "click": _vm.handlePointer
    }
  }, [[[_c('div', {
    staticClass: "comm-text normal-text"
  }, [_c('span', [_vm._v("最高返")]), _c('span', {
    staticClass: "commission-money"
  }, [_vm._v(_vm._s(_vm.promoter.promoterLevel.nowAllComm))])])], _vm.stringReturntype ? [_c('span', {
    staticClass: "comm-text normal-text"
  }, [_vm._v(_vm._s(_vm.stringReturntype))])] : _vm._e()], [[_vm.promoter.promoterLevel.toAllComm && _vm.promoter.promoterLevel.toAllComm !== _vm.promoter.promoterLevel.nowAllComm ? _c('div', {
    staticClass: "comm-text vip-text"
  }, [_c('span', [_vm._v("\n          升级\n          "), _vm._v("\n          " + _vm._s(_vm.promoter.promoterLevel.toLevelNoString) + "返\n          "), _c('span', {
    staticClass: "commission-money"
  }, [_vm._v(_vm._s(_vm.promoter.promoterLevel.toAllComm))])])]) : _vm._e()]]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };